<div class="page">
  <app-page-header page-title="stats.list.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card"
      *ngIf="loggedUserRoleType && (loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator')">
      <app-card-spinner [visible]="!data" type="zero">
      </app-card-spinner>
      <mat-card-title>{{ 'stats.list.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ "stats.dataUpdated" | translate }} {{ today | date }}</mat-card-subtitle>
      <mat-card-content class="card-content">
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-card>
              <!-- <app-card-spinner [visible]="!loggedUserRoleType || !data" type="zero">
              </app-card-spinner> -->
              <mat-card-title>
                {{ "stats.general" | translate }}
              </mat-card-title>
              <mat-card-content>
                <div class="row">
                  <div class="col-12">
                    <table class="table table-borderless table-striped">
                      <tbody>
                        <tr>
                          <td><strong>{{ "stats.companies" | translate }}</strong></td>
                          <td class="table-value">{{ data?.companiesCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.properties" | translate }}</strong></td>
                          <td class="table-value">{{ data?.propertiesCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.propertiesDisabled" | translate }}</strong></td>
                          <td class="table-value">{{ data?.propertiesDisabledCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.activeFullCount" | translate }}</strong></td>
                          <td class="table-value">{{ data?.activeFullCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.activeForfaitCount" | translate }}</strong></td>
                          <td class="table-value">{{ data?.activeForfaitCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.activeQRcodeSafetyCount" | translate }}</strong></td>
                          <td class="table-value">{{ data?.activeQRcodeSafetyCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.activeDossierCount" | translate }}</strong></td>
                          <td class="table-value">{{ data?.activeDossierCount }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- <div class="col-12 col-md-6">
                    <table class="table table-borderless table-striped">
                      <tbody>
                        <tr>
                          <td><strong>{{ "stats.missingRequired" | translate }}</strong></td>
                          <td class="table-value">{{ data?.totMandatory }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.mandatoryInserted" | translate }}</strong></td>
                          <td class="table-value">{{ data?.totMandatory - data?.totNotInsert }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.generics" | translate }}</strong></td>
                          <td class="table-value">{{ data?.totOptional }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div> -->
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-12 col-md-6">
            <mat-card class="doughnut-card">
              <!-- <app-card-spinner [visible]="!doughnutChartData" type="zero">
              </app-card-spinner> -->
              <mat-card-title>
                {{ "stats.turnover" | translate }}
              </mat-card-title>
              <mat-card-content>
                <div class="chart-container">
                  <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels"
                    [chartType]="doughnutChartType" [plugins]="doughnutChartPlugins" [options]="doughnutChartOptions"
                    [legend]="doughnutChartLegend" [colors]="doughnutChartColors">
                  </canvas>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <!-- FATTURATO ABBONAMENTI PER ADMIN -->
            <mat-card class="mt-4" *ngIf="data?.admins && data?.admins.length">
              <mat-card-title>
                {{ "stats.subscriptionsTurnover" | translate }}
              </mat-card-title>
              <mat-card-content>
                <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
                  <mat-expansion-panel-header class="card-expansion-trigger"
                    matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <mat-form-field>
                        <mat-label>{{ 'common.filter' | translate }}</mat-label>
                        <input matInput (keyup)="applySubscriptionsFilter($event)" placeholder="">
                      </mat-form-field>
                    </div>
                    <!-- <div class="col-12 col-md-6 text-right">
                    <button class="navigation-button" mat-flat-button (click)="onExport()" color="primary">
                      <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
                      {{ 'common.export' | translate }}
                    </button>
                  </div> -->
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <table class="table table-borderless table-striped" matSort
                        (matSortChange)="sortSubscriptionsData($event)" matSortDisableClear id="excel-table">
                        <thead>
                          <th>#</th>
                          <th class="clickable" mat-sort-header="name">
                            {{ 'stats.name' | translate }}</th>
                          <th class="clickable" mat-sort-header="full">
                            {{ 'stats.full' | translate }}</th>
                          <th class="clickable" mat-sort-header="free">
                            {{ 'stats.free' | translate }}</th>
                          <th class="clickable" mat-sort-header="test">
                            {{ 'stats.test' | translate }}</th>
                          <th class="clickable" mat-sort-header="contratti">
                            {{ 'stats.contratti' | translate }}</th>
                          <th class="clickable" mat-sort-header="checklist">
                            {{ 'stats.checklist' | translate }}</th>
                          <!-- <th class="clickable" mat-sort-header="pacchettofisso">
                            {{ 'stats.pacchettofisso' | translate }}</th> -->
                          <th class="clickable" mat-sort-header="qrsicurezza">
                              {{ 'stats.qrsicurezza' | translate }}</th>
                          <th class="clickable" mat-sort-header="nfcAccess">
                            {{ 'stats.nfcAccess' | translate }}</th>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of sortedSubscriptionsData; let i = index">
                            <th style="width: 3%">{{ i + 1 }}</th>
                            <td style="width: 20%">{{ item.adminName }}</td>
                            <td style="width: 10%">{{ item.full ? item.full.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.free ? item.free.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.test ? item.test.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.contratti ? item.contratti.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.checklist ? item.checklist.toFixed(2) + ' €' : '-' }}</td>
                            <!-- <td style="width: 10%">
                              {{ item.pacchettofisso ? item.pacchettofisso.toFixed(2) + ' €' : '-' }}</td> -->
                            <td style="width: 10%">{{ item.qrsicurezza ? item.qrsicurezza.toFixed(2) + ' €' : '-' }}
                            </td>
                            <td style="width: 10%">{{ item.nfcAccess ? item.nfcAccess.toFixed(2) + ' €' : '-' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-card-content>
            </mat-card>

            <!-- FATTURATO LISTINI PER ADMIN -->
            <mat-card class="mt-4" *ngIf="data?.admins && data?.admins.length">
              <mat-card-title>
                {{ "stats.pricesTurnover" | translate }}
              </mat-card-title>
              <mat-card-content>
                <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
                  <mat-expansion-panel-header class="card-expansion-trigger"
                    matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <mat-form-field>
                        <mat-label>{{ 'common.filter' | translate }}</mat-label>
                        <input matInput (keyup)="applyPricesFilter($event)" placeholder="">
                      </mat-form-field>
                    </div>
                    <!-- <div class="col-12 col-md-6 text-right">
                    <button class="navigation-button" mat-flat-button (click)="onExport()" color="primary">
                      <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
                      {{ 'common.export' | translate }}
                    </button>
                  </div> -->
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <table class="table table-borderless table-striped" matSort
                        (matSortChange)="sortPricesData($event)" matSortDisableClear id="excel-table">
                        <thead>
                          <th>#</th>
                          <th class="clickable" mat-sort-header="name">
                            {{ 'stats.name' | translate }}</th>
                          <th class="clickable" mat-sort-header="newDigitalDocFirstFile"
                            matTooltip="{{ 'stats.newDigitalDocFirstFileTooltip' | translate }}"
                            matTooltipPosition="above">
                            {{ 'stats.newDigitalDocFirstFile' | translate }}</th>
                          <th class="clickable" mat-sort-header="newDigitalDocOtherFile"
                            matTooltip="{{ 'stats.newDigitalDocOtherFileTooltip' | translate }}"
                            matTooltipPosition="above">
                            {{ 'stats.newDigitalDocOtherFile' | translate }}</th>
                          <th class="clickable" mat-sort-header="newPaperDocFirstFile"
                            matTooltip="{{ 'stats.newPaperDocFirstFileTooltip' | translate }}"
                            matTooltipPosition="above">
                            {{ 'stats.newPaperDocFirstFile' | translate }}</th>
                          <th class="clickable" mat-sort-header="newPaperDocOtherFile"
                            matTooltip="{{ 'stats.newPaperDocOtherFileTooltip' | translate }}"
                            matTooltipPosition="above">
                            {{ 'stats.newPaperDocOtherFile' | translate }}</th>
                          <th class="clickable" mat-sort-header="scanA0"
                            matTooltip="{{ 'stats.scanA0Tooltip' | translate }}" matTooltipPosition="above">
                            {{ 'stats.scanA0' | translate }}</th>
                          <th class="clickable" mat-sort-header="scanA1"
                            matTooltip="{{ 'stats.scanA1Tooltip' | translate }}" matTooltipPosition="above">
                            {{ 'stats.scanA1' | translate }}</th>
                          <th class="clickable" mat-sort-header="scanA2"
                            matTooltip="{{ 'stats.scanA2Tooltip' | translate }}" matTooltipPosition="above">
                            {{ 'stats.scanA2' | translate }}</th>
                          <th class="clickable" mat-sort-header="scanA3"
                            matTooltip="{{ 'stats.scanA3Tooltip' | translate }}" matTooltipPosition="above">
                            {{ 'stats.scanA3' | translate }}</th>
                          <th class="clickable" mat-sort-header="scanA4"
                            matTooltip="{{ 'stats.scanA4Tooltip' | translate }}" matTooltipPosition="above">
                            {{ 'stats.scanA4' | translate }}</th>
                          <th class="clickable" mat-sort-header="scanNoFormat"
                            matTooltip="{{ 'stats.scanNoFormatTooltip' | translate }}" matTooltipPosition="above">
                            {{ 'stats.scanNoFormat' | translate }}</th>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of sortedPricesData; let i = index">
                            <th style="width: 3%">{{ i + 1 }}</th>
                            <td style="width: 20%">{{ item.adminName }}</td>
                            <td style="width: 10%">
                              {{ item.newDigitalDocFirstFile ? item.newDigitalDocFirstFile.toFixed(2) + ' €' : '-' }}
                            </td>
                            <td style="width: 10%">
                              {{ item.newDigitalDocOtherFile ? item.newDigitalDocOtherFile.toFixed(2) + ' €' : '-' }}
                            </td>
                            <td style="width: 10%">
                              {{ item.newPaperDocFirstFile ? item.newPaperDocFirstFile.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">
                              {{ item.newPaperDocOtherFile ? item.newPaperDocOtherFile.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.scanA0 ? item.scanA0.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.scanA1 ? item.scanA1.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.scanA2 ? item.scanA2.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.scanA3 ? item.scanA3.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.scanA4 ? item.scanA4.toFixed(2) + ' €' : '-' }}</td>
                            <td style="width: 10%">{{ item.scanNoFormat ? item.scanNoFormat.toFixed(2) + ' €' : '-' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="custom-card"
      *ngIf="loggedUserRoleType && (loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator')">
      <app-card-spinner [visible]="!data" type="zero">
      </app-card-spinner>
      <mat-card-title>{{ 'stats.list.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ "stats.dataUpdated" | translate }} {{ today | date }}</mat-card-subtitle>
      <mat-card-content class="card-content">
        <div class="row">
          <div class="col-12">
            <mat-card>
              <mat-card-title class="text-center">
                {{ "stats.general" | translate }}
              </mat-card-title>
              <mat-card-content>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <table class="table table-borderless table-striped">
                      <tbody>
                        <tr>
                          <td><strong>{{ "stats.users" | translate }}</strong></td>
                          <td class="table-value">{{ data?.usersCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.properties" | translate }}</strong></td>
                          <td class="table-value">{{ data?.propertiesCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.accessLogs" | translate }}</strong></td>
                          <td class="table-value">{{ data?.accessLogsCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.deadlines" | translate }}</strong></td>
                          <td class="table-value">{{ data?.deadlinesCount }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.totalBox" | translate }}</strong></td>
                          <td class="table-value">{{ data?.totalBox }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12 col-md-6">
                    <table class="table table-borderless table-striped">
                      <tbody>
                        <tr>
                          <td><strong>{{ "stats.mandatoryInserted" | translate }}</strong></td>
                          <td class="table-value">{{ data?.totInsert }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.missingRequired" | translate }}</strong></td>
                          <td class="table-value">{{ data?.totNotInsert }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.generics" | translate }}</strong></td>
                          <td class="table-value">{{ data?.totOptional }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ "stats.totalProperties" | translate }}</strong></td>
                          <td class="table-value">{{ data?.totalProperties }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- <div class="row mt-4 mb-5">
                  <div class="col-4">
                    <strong>{{ 'home.progressbar' | translate }}</strong>
                  </div>
                  <div class="col-12 col-md-6 progressbar">
                    <div class="inserted" [ngStyle]="progressBarValStyle">
                    </div>
                  </div>
                  <div class="col-2">
                    <strong>{{ progressBarVal }} %</strong>
                  </div>
                </div> -->
              </mat-card-content>
            </mat-card>
          </div>
          <!-- since req user is a master, he's the only admin in the array,
            so we're sure that data is inside admins[0] -->
          <div class="col-12" *ngFor="let item of data?.admins[0]?.structures">
            <mat-card *ngIf="structuresToDisplay.includes(item.title)">
              <mat-card-title class="text-center">
                {{ 'properties.structures.' + item.title | translate }}
              </mat-card-title>
              <mat-card-content>
                <div class="row justify-content-center">
                  <div class="col-12 col-sm-10 col-md-8 col-lg-6">
                    <table class="table table-borderless table-striped">
                      <thead>
                        <th style="color: #e56c11;" *ngIf="item.title !== 'additionalData'">
                          <div class="row">
                            <div class="col-10">
                              Nome elemento
                            </div>
                            <div class="col-2 text-right">
                              Quantità
                            </div>
                          </div>
                        </th>
                        <th style="color: #e56c11;" *ngIf="item.title === 'additionalData'">
                          <div class="row">
                            <div class="col-9">
                              Nome elemento
                            </div>
                            <div class="col-2 text-right">
                              Quantità
                            </div>
                            <div class="col-1">
                            </div>
                          </div>
                        </th>
                      </thead>
                      <tbody>
                        <tr *ngFor="let subItem of item.content | keyvalue">
                          <a class="w-100" mat-button (click)="onStructureDetailDialogOpen(subItem.key)">
                            <td class="table-title-column">
                              <div class="row">
                                <div class="col-9" [ngClass]="{ 'col-9': item.title === 'additionalData', 'col-10': item.title !== 'additionalData'}">
                                  <strong>{{ 'properties.structures.' + subItem.key | translate }}</strong>
                                </div>
                                <div class="col-2 text-right align-self-center">
                                  {{ subItem.value }}
                                </div>
                                <div class="col-1" *ngIf="item.title === 'additionalData'">
                                  <button mat-icon-button aria-label="Info" (mouseover)="onInfoPopUp(subItem.key)"
                                    *ngIf="('stats.tooltip.' + subItem.key + '.title' | translate) !== ''">
                                    <mat-icon fontSet="fal" fontIcon="fa-info-circle" class="icon-action"></mat-icon>
                                  </button>
                                </div>
                              </div>
                            </td>
                          </a>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->